"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextMenu = _interopRequireDefault(require("./TextMenu"));

var _ImageMenu = _interopRequireDefault(require("./ImageMenu"));

var _utils = require("../utils");

var _MenuController = _interopRequireDefault(require("../../assets/MenuController.css"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _hammerjs = _interopRequireDefault(require("hammerjs"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Arrow = _interopRequireDefault(require("./Arrow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_MenuController["default"]); // document.addEventListener(
//   "touchmove",
//   function (event) {
//     event.preventDefault();
//   },
//   { passive: false },
// );


var MenuController = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuController, _React$PureComponent);

  function MenuController() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      allShow: true
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSwitch", function () {
      var isShow = _this.props.isShow;

      if (isShow) {
        _this.props.onClose();
      } else {
        _this.props.onOpen();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickMenu", function (level, menu, id) {
      var onClickMenu = _this.props.onClickMenu;
      onClickMenu && onClickMenu(level, menu, id);
    });

    _defineProperty(_assertThisInitialized(_this), "onPanUp", function () {
      _this.props.onOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "onPanDown", function () {
      _this.props.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (menu, level) {
      var _this$props = _this.props,
          isShow = _this$props.isShow,
          THUMB_DOMAIN = _this$props.THUMB_DOMAIN,
          urlSplicing = _this$props.urlSplicing,
          disableTip = _this$props.disableTip,
          selectedAll = _this$props.selectedAll,
          animation = _this$props.animation,
          seenScenes = _this$props.seenScenes,
          payScenes = _this$props.payScenes,
          ui = _this$props.ui,
          selectedChangeResize = _this$props.selectedChangeResize,
          extData = _this$props.extData;
      var selected = selectedAll[level];
      var current = (0, _utils.getCurrent)(menu, selected);
      var props = {
        isShow: isShow,
        animation: animation,
        data: menu,
        selected: selected,
        onClick: _this.onClickMenu.bind(_assertThisInitialized(_this), level, menu),
        THUMB_DOMAIN: THUMB_DOMAIN,
        urlSplicing: urlSplicing,
        seenScenes: seenScenes,
        payScenes: payScenes,
        disableTip: disableTip,
        theme: 3,
        ui: ui,
        selectedChangeResize: selectedChangeResize,
        extData: extData
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, current && current.children ? menu.length > 1 ? /*#__PURE__*/_react["default"].createElement(_TextMenu["default"], _extends({}, props, {
        theme: level !== 0 ? 103 : 3
      })) : null : /*#__PURE__*/_react["default"].createElement(_ImageMenu["default"], props), current && current.children ? _this.renderMenu(current.children, level + 1) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrow", function () {
      var _this$props2 = _this.props,
          _this$props2$extData = _this$props2.extData,
          extData = _this$props2$extData === void 0 ? {} : _this$props2$extData,
          isShow = _this$props2.isShow,
          buttonTitle = _this$props2.buttonTitle,
          language = _this$props2.language,
          ui = _this$props2.ui;
      var existCustomButton = extData.existCustomButton;
      if (existCustomButton) return;
      return isShow ? /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        onClick: _this.onClickSwitch,
        vertical: "center",
        className: cx("arrowBottomBox")
      }, /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
        fill: ui == null ? void 0 : ui.fontColor
      })) : /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        style: {
          background: ui.panelBgColor
        },
        horizontal: "center",
        layout: "vertical",
        onClick: _this.onClickSwitch,
        className: cx("arrowTop")
      }, /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
        style: {
          transform: "rotate(180deg)",
          marginBottom: 5
        },
        fill: ui == null ? void 0 : ui.fontColor
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: ui == null ? void 0 : ui.fontColor
        }
      }, buttonTitle && buttonTitle !== "" ? buttonTitle : language === 2 ? "List" : "场景选择"));
    });

    return _this;
  }

  var _proto = MenuController.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.createHammer();
  };

  _proto.createHammer = function createHammer() {
    var mc = new _hammerjs["default"].Manager(this.container);
    mc.add(new _hammerjs["default"].Swipe());
    mc.get("swipe").set({
      direction: _hammerjs["default"].DIRECTION_ALL
    });
    mc.on("swipeup", this.onPanUp);
    mc.on("swipedown", this.onPanDown);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        category = _this$props3.category,
        isShow = _this$props3.isShow,
        buttonTitle = _this$props3.buttonTitle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(me) {
        return _this2.container = me;
      }
    }, this.renderArrow(), this.renderMenu(category, 0));
  };

  return MenuController;
}(_react["default"].PureComponent);

var _default = MenuController;
exports["default"] = _default;
module.exports = exports.default;